import { useEffect } from "react";
import { useNotifications } from "./NotificationManager.js";

const NotificationContainer = () => {
    const { notifications, removeNotification } = useNotifications();

    useEffect(() => {
        notifications.forEach(({ id }) => {
            setTimeout(() => removeNotification(id), 4000); // Chaque notification disparaît après 4 secondes
        });
    }, [notifications, removeNotification]);

    const handleDelete = (id) => {
        removeNotification(id);
    };

    const backgroundColors = {
        success: '#4CAF50',
        error: '#F44336',
        alert: '#FFC107',
    };

    return (
        <div style={{ position: 'fixed', top: 20, right: 20, zIndex: 1000, maxWidth: '400px' }}>
            {notifications.map(({ id, title, type, description, link }) => (
                <div key={id} style={{ position: 'relative', marginTop: 10, padding: '10px 20px', backgroundColor: backgroundColors[type] || 'lightgrey', borderRadius: 5, color: 'white' }}>
                    <strong>{title}</strong> <span style={{ position: 'absolute', right: '10px', top: '-5px', cursor: 'pointer', color: 'white', fontSize: '1.3em' }} onClick={() => handleDelete(id)}>x</span>
                    {description && <div>{description}</div>}
                    {link && <div><a href={link} target="_blank" rel="noopener noreferrer" style={{ color: '#AAF', textDecoration: 'underline' }}>Accéder</a></div>}
                </div>
            ))}
        </div>
    );
};

export default NotificationContainer;
